import React from "react";
import { Outlet } from "react-router-dom";
import BannerBox from "./BannerBox";

const SupportPortalLayout = () => {
  return (
    <div
      style={{
        height: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        margin: "-15px",
        padding: "15px",
      }}
    >
      <BannerBox />
      <Outlet />
    </div>
  );
};

export default SupportPortalLayout;
